import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../assets/fonts/Hack-NF.ttf%22,%22variable%22:%22--font-hack%22,%22fallback%22:[%22monospace%22]}],%22variableName%22:%22hackFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'hackFont', 'hackFont Fallback', monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
